// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/side.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/side.proto.
 */
export const file_bfftypes_v1_side: GenFile = /*@__PURE__*/
  fileDesc("ChZiZmZ0eXBlcy92MS9zaWRlLnByb3RvEgtiZmZ0eXBlcy52MSo5CgRTaWRlEhQKEFNJREVfVU5TUEVDSUZJRUQQABIMCghTSURFX0JVWRABEg0KCVNJREVfU0VMTBACQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * Side is the direction of a bilateral electricity trade (= 売 / 買)。
 * Hosted under bfftypes/v1 because supply / demand / position / bid-limit
 * 等の BFF service が共通でこの分類を必要とする。
 *
 * Wire values mirror backend types.v1.Side but the enum is kept BFF-local
 * so that BFF's contract with the frontend stays decoupled from backend
 * internal types.
 *
 * @generated from enum bfftypes.v1.Side
 */
export enum Side {
  /**
   * @generated from enum value: SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SIDE_BUY = 1;
   */
  BUY = 1,

  /**
   * @generated from enum value: SIDE_SELL = 2;
   */
  SELL = 2,
}

/**
 * Describes the enum bfftypes.v1.Side.
 */
export const SideSchema: GenEnum<Side> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_side, 0);

